<template>
  <mymodal ref="theModal" :need-header="true" :need-footer="false" :size="'medium'">
    <div slot="title">{{getTitleText}}</div>
    <div slot="body">
      <form v-on:submit.prevent="submitForm">
        <label>{{'Number of stamps'|translate}}</label>
        <input
          type="number"
          v-model="item.stamp_number"
          required
          ref="stamp_number"
          :placeholder="'Number of stamps'|translate"
          class="form-control"
        />
        <p>
          <small>{{'Do not input over'|translate}} {{max_value}}, {{'Available stamp do not over'|translate}} {{max_available}}</small>
        </p>
        <button class="btn btn-info mt20" type="submit" :disabled="working">
          <i v-if="working" class="fas fa-spinner fa-spin"></i>
          {{getOKText}}
        </button>
      </form>
    </div>
  </mymodal>
</template>
<script>
import mymodal from "@/components/elements/Modal";
import Utils from "@/helpers/utils";

export default {
  name: "FormSerial",
  components: {
    mymodal
  },
  props: [],
  computed: {
    getTitleText() {
      if (this.item.id) {
        return this.$t("Update harvest");
      } else {
        return this.$t("General list stamp");
      }
    },
    getOKText() {
      if (this.item.id) {
        return this.$t("Update");
      } else {
        return this.$t("Add");
      }
    }
  },
  data() {
    return {
      working: false,
      max_value: 10000,
      max_available: 100000,
      item: {}
    };
  },
  created() {
    // clone from original params
  },
  methods: {
    defaultValue() {
      return {
        stamp_number: 1000
      };
    },
    open() {
      this.$refs.theModal.open();
      this.item = this.defaultValue();

      //   for (let key in this.searchparams) {
      //     this.search_params[key] = this.searchparams[key]
      //   }
    },
    submitForm() {
      let data = JSON.parse(JSON.stringify(this.item));

      this.working = true;
      let request;

      request = Utils.request(this, true).post(`/manageSerial/`, data);

      request
        .then(response => {
          this.working = false;
          
          if (response.data.status == "error") {
            Utils.showError(this, this.$t(response.data.data));
          } else {
            this.$refs.theModal.close();
            this.$emit("modalData", {});
          }
        })
        .catch(error => {
          this.working = false;
          Utils.showErrorMessage(this, error.response);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Cultivation/FormSerial.vue